<!-- TO DO: Check with PO and after approval, delete all variables related to contactManagement -->
<!-- <mat-slide-toggle
    [checked]="contactManagement"
    (toggleChange)="toggleContactManagement()"
    class="margin-button"
    >Kontakte verwalten</mat-slide-toggle
> -->
<div>
    <div class="contact-header">
        <h2>Kontakt</h2>
        <mat-icon matSuffix class="info-icon"
            matTooltip="Demo- und Angebotsanfragen von der Produktseite werden an diesen Kontakt gesendet. Ist kein Kontakt hinterlegt, sind diese Funktionen deaktiviert."
            matTooltipPosition="above" tabindex="-1" style="margin-top: 5px;">
            info_outline
        </mat-icon>
    </div>
    <div class="table" *ngIf="contacts && contacts.length > 0; else noContacts">
        <div class="row" style="background-color: transparent;">
            <div>
                <span><b>Name</b></span>
            </div>
            <div>
                <span><b>E-Mail</b></span>
            </div>
        </div>
        <div *ngFor="let contact of contacts" class="row-container">
            <div class="row">
                <div class="row-item">
                    <span [class]="contact.edit && 'bold'">
                        {{ contact.contactName }}
                    </span>
                </div>
                <div class="row-item">
                    <span [class]="contact.edit && 'bold'">
                        {{ contact.email }}
                    </span>
                </div>
                <div class="row-item-btns">
                    <div class="mini-hex-button" [matTooltip]="'Kontakt bearbeiten'" [matTooltipPosition]="'below'">
                        <hexagon [icon]="'edit'" [hover]="true" [outerColor]="'var(--app-primary)'"
                            (click)="toggleContactEdit(contact)">
                        </hexagon>
                    </div>
                    <div class="mini-hex-button" [matTooltip]="'Kontakt löschen'" [matTooltipPosition]="'below'">
                        <hexagon [icon]="'minus'" [hover]="true" [outerColor]="'var(--app-primary)'"
                            (click)="deleteOrganisationContact(contact)">
                        </hexagon>
                    </div>
                </div>
            </div>
            <app-contact-form class="contact-form-edit" *ngIf="contact.edit" [contactInput]="contact"
                (done)="editOrganisationContact($event)" (cancel)="toggleContactEdit(contact)">
            </app-contact-form>
        </div>
    </div>
    <ng-template #noContacts>
        <p><em>Es sind derzeit keine Kontakte hinterlegt.
                Bitte geben Sie mindestens einen Kontakt an, um Angebots- und Demoanfragen
                empfangen zu können.</em>
        </p>
    </ng-template>
    <div class="contact-form-container">
        <h2>Kontakt erstellen</h2>
        <mat-slide-toggle style="margin-top: -1rem; max-width: fit-content;" [checked]="contactCreation"
            (toggleChange)="toggleContactCreation()" class="margin-button">Kontakt erstellen
        </mat-slide-toggle>
        <app-contact-form *ngIf="contactCreation" (done)="createOrganisationContact($event)"></app-contact-form>
    </div>
</div>

<div *ngIf="isLoading" class="loading-overlay-spinner">
    <mat-spinner></mat-spinner>
</div>